import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompanyInformationForm = ({ formData, updateFormData, errors }) => {
  const industryOptions = [
    { value: 'manufactura', label: 'Manufactura' },
    { value: 'retail', label: 'Retail y Comercio' },
    { value: 'servicios', label: 'Servicios Profesionales' },
    { value: 'construccion', label: 'Construcción' },
    { value: 'logistica', label: 'Logística y Transporte' },
    { value: 'salud', label: 'Salud y Farmacéutica' },
    { value: 'educacion', label: 'Educación' },
    { value: 'tecnologia', label: 'Tecnología' },
    { value: 'financiero', label: 'Servicios Financieros' },
    { value: 'otro', label: 'Otro' }
  ];

  const employeeCountOptions = [
    { value: '1-10', label: '1-10 empleados' },
    { value: '11-50', label: '11-50 empleados' },
    { value: '51-200', label: '51-200 empleados' },
    { value: '201-500', label: '201-500 empleados' },
    { value: '500+', label: 'Más de 500 empleados' }
  ];

  // La constante 'revenueOptions' ya no es necesaria, 

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Nombre de la Empresa"
          type="text"
          placeholder="Ingrese el nombre de su empresa"
          value={formData.companyName || ''}
          onChange={(e) => updateFormData('companyName', e.target.value)}
          error={errors.companyName}
          required
        />

        <Select
          label="Industria"
          placeholder="Seleccione su industria"
          options={industryOptions}
          value={formData.industry || ''}
          onChange={(value) => updateFormData('industry', value)}
          error={errors.industry}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Número de Empleados"
          placeholder="Seleccione el tamaño de su empresa"
          options={employeeCountOptions}
          value={formData.employeeCount || ''}
          onChange={(value) => updateFormData('employeeCount', value)}
          error={errors.employeeCount}
          required
        />

        {/* El campo de Ingresos Anuales ha sido eliminado de aquí */}
        
        <Input
          label="País"
          type="text"
          placeholder="Ingrese su país"
          value={formData.country || ''}
          onChange={(e) => updateFormData('country', e.target.value)}
          error={errors.country}
          required
        />
      </div>

      <Input
        label="Sitio Web"
        type="url"
        placeholder="https://www.empresa.com"
        value={formData.website || ''}
        onChange={(e) => updateFormData('website', e.target.value)}
        error={errors.website}
      />

      <Input
        label="Descripción del Negocio"
        type="text"
        placeholder="Breve descripción de su modelo de negocio y principales actividades"
        value={formData.businessDescription || ''}
        onChange={(e) => updateFormData('businessDescription', e.target.value)}
        error={errors.businessDescription}
        description="Ayúdanos a entender mejor su negocio para personalizar nuestra consultoría"
      />
    </div>
  );
};

export default CompanyInformationForm;